const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
const SPRING_STIFFNESS = 140;
const SPRING_DAMPING = 14;
const REST_POSITION_THRESHOLD = 0.1;
const REST_VELOCITY_THRESHOLD = 0.1;

class MiniMinionsStripe extends HTMLElement {
  constructor() {
    super();

    this.rows = [];
    this.position = 0;
    this.target = 0;
    this.velocity = 0;
    this.frameId = 0;
    this.lastTimestamp = 0;
    this.reducedMotion = window.matchMedia(REDUCED_MOTION_QUERY);

    this.handleScroll = this.handleScroll.bind(this);
    this.handleMotionPreference = this.handleMotionPreference.bind(this);
    this.updateSpring = this.updateSpring.bind(this);
  }

  connectedCallback() {
    this.rows = Array.from(this.querySelectorAll("[data-stripe-scroll-factor]")).map(
      (row) => ({
        element: row,
        factor: Number(row.dataset.stripeScrollFactor) || 0,
      })
    );

    this.position = window.scrollY;
    this.target = this.position;
    this.render(this.reducedMotion.matches ? 0 : this.position);

    window.addEventListener("scroll", this.handleScroll, { passive: true });
    this.reducedMotion.addEventListener("change", this.handleMotionPreference);
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
    this.reducedMotion.removeEventListener("change", this.handleMotionPreference);
    cancelAnimationFrame(this.frameId);
    this.frameId = 0;
  }

  handleScroll() {
    if (this.reducedMotion.matches) return;

    this.target = window.scrollY;
    this.startSpring();
  }

  handleMotionPreference(event) {
    cancelAnimationFrame(this.frameId);
    this.frameId = 0;
    this.velocity = 0;
    this.position = window.scrollY;
    this.target = this.position;
    this.render(event.matches ? 0 : this.position);
  }

  startSpring() {
    if (this.frameId) return;

    this.lastTimestamp = performance.now();
    this.frameId = requestAnimationFrame(this.updateSpring);
  }

  updateSpring(timestamp) {
    const deltaTime = Math.min((timestamp - this.lastTimestamp) / 1000, 0.032);
    const displacement = this.target - this.position;
    const acceleration = displacement * SPRING_STIFFNESS;

    this.lastTimestamp = timestamp;
    this.velocity += acceleration * deltaTime;
    this.velocity *= Math.exp(-SPRING_DAMPING * deltaTime);
    this.position += this.velocity * deltaTime;
    this.render(this.position);

    const isMoving =
      Math.abs(this.target - this.position) > REST_POSITION_THRESHOLD ||
      Math.abs(this.velocity) > REST_VELOCITY_THRESHOLD;

    if (isMoving) {
      this.frameId = requestAnimationFrame(this.updateSpring);
      return;
    }

    this.position = this.target;
    this.velocity = 0;
    this.frameId = 0;
    this.render(this.position);
  }

  render(scrollPosition) {
    this.rows.forEach(({ element, factor }) => {
      element.style.setProperty("--stripe-scroll-x", `${scrollPosition * factor}px`);
    });
  }
}

if (!customElements.get("mini-minions-stripe")) {
  customElements.define("mini-minions-stripe", MiniMinionsStripe);
}
